import { Category } from './Category';

export class CategoryWithSubcategories extends Category {
  constructor(data) {
    super(data);
    
    if (!data.id) {
      throw new Error('Category ID is required');
    }
    if (!data.labels) {
      throw new Error('Category labels are required');
    }
    if (!data.icon) {
      throw new Error('Category icon is required');
    }

    this.subcategories = data.subcategories || [];
    
    // Valider la structure des sous-catégories
    this.subcategories.forEach(sub => {
      if (!sub.id) {
        throw new Error('Subcategory ID is required');
      }
    });
  }

  findSubcategory(id) {
    return this.subcategories.find(sub => sub.id === id) || null;
  }

  getSubcategoryLabel(id, lang = 'en') {
    const subcategory = this.findSubcategory(id);
    if (!subcategory) return undefined;
    return subcategory[lang] || subcategory.en;
  }
} 